import { OpenDialog } from "event-definitions"
import { nanoid } from "nanoid"
import { ConfirmDialog } from "lib/@dialogs/confirm-dialog"

/**
 * Renders a confirmation message and waits for a user response
 * @param {string} message - the message to confirm
 * @param {string} title - the title of the confirmation box
 * @param {string[]} [buttons] - optional custom button labels
 * @param {string} [okText] - label for the confirm button
 * @param {{okColor?: string, okIcon?: string, cancelIcon?: string}} [options] - styling for the confirm/cancel buttons
 * @returns {Promise<boolean>} the selection the user made
 */
export function confirm(message, title = "", buttons = undefined, okText, options = {}) {
    return new Promise((resolve) => {
        OpenDialog.raise({
            dialogProps: {
                maxWidth: "sm",
                fullWidth: true,
            },
            dialogId: nanoid(),
            content: <ConfirmDialog buttons={buttons} message={message} title={title} okText={okText} {...options} />,
            resolve,
        })
    })
}
